<template>
  <div class="container">
    <div v-show="!isEdit">
      <NavBar>一键呼叫</NavBar>
      <div class="box">
        <div class="header">
          <div class="title">常用行程设置</div>
          <div class="desc">
            您可以设置常用的行程信息，将在主页为您展示入口，点击后可一键为您下单叫车。目前仅支持下单1人车票。
            单个区域最多可设置6个常用行程。
            当您使用一键呼叫时，即视为您已同意购票协议及乘车协议。
          </div>
        </div>
        <div class="list">
          <state-loading v-if="isLoading" />
          <template v-else>
            <div
              v-for="(item, index) in list"
              :key="index"
              class="item"
              @click="onDetail(item)"
            >
              <div class="item-header">
                <div class="item-title">{{ item.lineName }}</div>
                <img src="../../assets/img-v2/ic_user_arrow.png" class="item-arrow"/>
              </div>
              <div class="item-stop">
                <span class="item-stop-icon item-stop-on"></span>
                <span class="item-stop-name">{{ item.onName }}</span>
              </div>
              <div class="item-stop">
                <span class="item-stop-icon item-stop-off"></span>
                <span class="item-stop-name">{{ item.offName }}</span>
              </div>
              <div v-if="item.type === 1" class="item-tip">
                站点失效，请重新编辑
              </div>
            </div>
          </template>
        </div>
        <div class="btn" @click="onAdd">
          <img src="../../assets/img-v2/ic_call_add.png" class="icon" />
          新增常用行程
        </div>
      </div>
    </div>
    <!-- 编辑 -->
    <div v-if="isEdit">
      <Edit :info="row" @back="onBack" />
    </div>
  </div>
</template>

<script>
import StateLoading from '../../components/state-loading'
import NavBar from '../../components/nav-bar'
import Edit from './components/Edit.vue'
import { getCallList } from './api/index'

export default {
  components: {
    StateLoading,
    NavBar,
    Edit
  },
  data() {
    return {
      isLoading: false,
      list: [],
      isEdit: false,
      row: null
    }
  },
  activated() {
    if (!this.isEdit) {
      this.reuestCallList()
    }
  },
  beforeRouteLeave(to, from, next) {
    this.isEdit = to.name === 'Poi'
    next()
  },
  methods: {
    reuestCallList() {
      const userId = this.$UserService.getUserId()
      if (!userId) return
      const cityId = this.$AppService.getCityId()
      this.isLoading = true
      return getCallList({
        userId,
        cityId
      })
        .then(res => {
          this.list = res || []
        })
        .catch(err => {
          this.$toast(err.msg || '未知异常')
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    onAdd() {
      this.isEdit = true
      this.row = null
    },
    onDetail(data) {
      this.isEdit = true
      this.row = data
    },
    onBack() {
      this.isEdit = false
      this.reuestCallList()
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  min-height: 100%;
  background: #F3F4F5;
  -webkit-overflow-scrolling: touch;
}
.box {
  padding: 10px;
}
.header {
  background: #FFFFFF;
  border-radius: 12px;
  padding: 0 14px 16px 14px;
}
.title {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #000000;
  line-height: 22px;
  padding: 13px 0;
}
.desc {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
  line-height: 20px;
}
.btn {
  height: 48px;
  background: #FFFFFF;
  border-radius: 25px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #006EFA;
  line-height: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  img {
    width: 16px;
    height: 16px;
    margin-right: 10px;
  }
}
.list {
}
.item {
  position: relative;
  padding: 0 14px;
  margin: 10px 0;
  background: #ffffff;
  border-radius: 12px;
  &-header {
    display: flex;
    align-items: center;
    padding: 23px 0;
  }
  &-title {
    flex: 1;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #000000;
    line-height: 22px;
    display: flex;
    align-items: center;
  }
  &-arrow {
    width: 12px;
    height: 12px;
  }
  &-stop {
    padding-bottom: 18px;
    display: flex;
    align-items: center;
    &-icon {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      margin-right: 8px;
    }
    &-on {
      background: #04B47C;
    }
    &-off {
      background: #006EFA;
    }
    &-name {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: rgba(0,0,0,0.7);
      line-height: 22px;
    }
  }
  &-tip {
    position: absolute;
    top: 0;
    right: 0;
    font-size: 13px;
    font-weight: 500;
    padding: 5px;
    color: #ff4d4f;
  }
}
</style>
